import { useSelector } from 'react-redux';
import store from 'src/store';

export const CONFIG_REDUX_PATHS = {
	tenant_settings: 'settings',
} as const;

export const DEFAULT_TENANT_CURRENCY = 'USD';

export const get_tenant_settings = () => {
	const state: any = store.getState();
	const tenant_settings: any = state[CONFIG_REDUX_PATHS.tenant_settings];

	return tenant_settings;
};

/** Non-reactive snapshot — use only outside React render (utils, ag-grid valueFormatters). In components, use `useTenantCurrency`. */
export const get_tenant_currency = () => {
	const tenant_settings = get_tenant_settings();
	return tenant_settings?.currency || DEFAULT_TENANT_CURRENCY;
};

/** Re-renders once tenant settings load — they aren't persisted, so they arrive shortly after a page refresh. */
export const useTenantCurrency = (): string =>
	useSelector((state: any) => state?.[CONFIG_REDUX_PATHS.tenant_settings]?.currency) || DEFAULT_TENANT_CURRENCY;
